import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import List from './List'

interface DetailsProps {
  id: number
}

const Details: React.FC<DetailsProps> = (props) => {
  const { id } = props
  return (
    <Card
      title='Position'
    >
      <Suspense fallback={<List details={undefined} rates={undefined} />}>
        <Body id={id} />
      </Suspense>
    </Card>
  )
}

export default Details
